import React from 'react';

import { useCMSUContext } from '../../../hooks/useCMSUContext';
import { ButtonLink } from '../../../modules/ActionGroup/ButtonLink';
import { ImageLink } from '../../../modules/ActionGroup/ImageLink';
import { TextLink } from '../../../modules/ActionGroup/TextLink';
import { getElementAction } from '../../../utils/getElementAction';
import { toUrl } from '../../../utils/toUrl';
import type { ActionRenderers } from '../ActionRenderer';
import { DialogButton } from '../../../modules/ActionGroup/DialogButton';

export const universal: ActionRenderers = {
  CTextLink: (props) => {
    const { language } = useCMSUContext();
    const url = toUrl(props.link?.to, language);
    return (
      <TextLink
        {...props}
        uniqueTrackingId="text-link"
        trackingAttributes={{
          elementText: props.text,
          elementAction: getElementAction(props.link?.to),
          elementLink: url,
        }}
      />
    );
  },
  CButtonLink: (props) => {
    const { language, utmParameters } = useCMSUContext();
    return (
      <ButtonLink
        link={toUrl(props.link?.to, language, utmParameters)}
        text={props.text}
        tone={props.tone || 'neutral'}
        variant={props.variant || 'solid'}
        size={props.size || 'standard'}
        icon={props.icon}
        iconPosition={props.iconPosition}
        openLinkInNewTab={props.link?.openLinkInNewTab || false}
        uniqueTrackingId="button-link"
        trackingAttributes={{
          elementText: props.text,
          elementAction: getElementAction(props.link?.to),
          elementLink: toUrl(props.link?.to, language, utmParameters),
        }}
      />
    );
  },
  CImageLink: (props) => {
    const url = toUrl(props.link?.to);
    return (
      <ImageLink
        {...props}
        uniqueTrackingId="image-link"
        trackingAttributes={{
          elementText: props.image?.alt || '',
          elementAction: getElementAction(props.link?.to),
          elementLink: url,
        }}
      />
    );
  },
  DialogButton: (props) => (
      <DialogButton {...props}
        uniqueTrackingId="dialog-button"
        trackingAttributes={{
          elementText: props.text,
          elementAction: getElementAction(undefined),
        }}
      />
    ),
};
